export default __webpack_public_path__ + "static/media/DonnisiraLogo.445ca102.svg";